import { render, staticRenderFns } from "./scheduleMessageStatistics.vue?vue&type=template&id=95b4ecea&scoped=true&"
import script from "./scheduleMessageStatistics.vue?vue&type=script&lang=js&"
export * from "./scheduleMessageStatistics.vue?vue&type=script&lang=js&"
import style0 from "./scheduleMessageStatistics.vue?vue&type=style&index=0&id=95b4ecea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b4ecea",
  null
  
)

component.options.__file = "scheduleMessageStatistics.vue"
export default component.exports